import styled from 'styled-components';
import { ChartDimensions } from '@ardoq/graph';
import { colors } from '@ardoq/design-tokens';
import { XAxisTickmark, XGridLine } from '../xAxis/styles';

const XGridlinesContainer = styled.div`
  height: 100%;
  min-height: 100%;
`;

const XMajorGridline = styled(XGridLine)`
  border-left-color: ${colors.grey300};
`;

type XGridLinesArgs = {
  positions: number[];
  dimensions: ChartDimensions;
  children?: React.ReactNode;
};
export const XGridLines = ({
  dimensions: {
    margin: { left: marginLeft },
    chart: { width: chartWidth },
  },
  positions,
  children,
}: XGridLinesArgs) => (
  <XGridlinesContainer
    style={{
      left: 0,
      width: chartWidth + 1,
    }}
  >
    {positions.map(position => (
      <XMajorGridline key={position} style={{ left: position - marginLeft }} />
    ))}
    <XAxisTickmark
      style={{
        right: -1,
        width: 1,
        height: '100%',
      }}
    />
    {children}
  </XGridlinesContainer>
);
